import { ReactNode } from 'react'
import { ShieldAlert } from 'lucide-react'
import { cn } from '@/lib/utils'

interface NoPermissionViewProps {
  /**
   * 主訊息（預設「沒有權限」）。
   */
  title?: string
  /**
   * 補充說明（預設「請聯絡管理員開通此功能的存取權限」）。
   */
  description?: string
  /**
   * 客製 icon，覆蓋預設的 ShieldAlert。
   */
  icon?: ReactNode
  className?: string
}

/**
 * 共用「沒有權限」畫面。當使用者打到 403 / 沒有 permission 時顯示，
 * 取代「載入失敗」這種容易誤導的訊息。
 *
 * 用法：
 * ```tsx
 * if (isError && (error?.error?.code === 'FORBIDDEN')) {
 *   return <NoPermissionView />
 * }
 * ```
 */
export function NoPermissionView({
  title = '沒有權限',
  description = '請聯絡管理員開通此功能的存取權限',
  icon,
  className,
}: NoPermissionViewProps) {
  return (
    <div
      className={cn(
        'flex flex-col items-center justify-center text-center py-16 px-4',
        className,
      )}
    >
      <div className="p-4 rounded-full bg-muted/50 mb-4">
        {icon ?? <ShieldAlert className="h-12 w-12 text-muted-foreground" />}
      </div>
      <h3 className="text-lg font-semibold mb-1">{title}</h3>
      <p className="text-sm text-muted-foreground max-w-md">{description}</p>
    </div>
  )
}
